module.exports = __webpack_public_path__ + "img/y2.9446a99b.jpg";